import { returnRequests, formatMoney, type ReturnRequest } from "@/mocks/managerWorkspace";

export default function ReturnRequestsWidget() {
  return (
    <div className="bg-white rounded-lg border border-[#D5CA8A] overflow-hidden h-full flex flex-col">
      <div className="flex items-center justify-between px-3 py-2 bg-[#FEF3C7] border-b border-[#D5CA8A]">
        <div className="flex items-center gap-1.5">
          <i className="ri-arrow-go-back-line text-[12px] text-[#2D2D2D]"></i>
          <span className="text-[11px] font-semibold text-[#2D2D2D]">Заявки на возврат</span>
        </div>
        <span className="text-[11px] font-bold text-[#2D2D2D]">{returnRequests.length}</span>
      </div>
      <div className="flex-1 overflow-auto">
        <table className="w-full text-[10px]">
          <thead>
            <tr className="bg-[#FDF2B5]/50 text-[#666666]">
              <th className="text-left px-2 py-1 font-medium">№ заявки</th>
              <th className="text-left px-2 py-1 font-medium">Клиент</th>
              <th className="text-left px-2 py-1 font-medium">Документ продажи</th>
              <th className="text-left px-2 py-1 font-medium">Причина</th>
              <th className="text-left px-2 py-1 font-medium">Сумма</th>
              <th className="text-left px-2 py-1 font-medium">Статус</th>
            </tr>
          </thead>
          <tbody>
            {returnRequests.slice(0, 6).map((r: ReturnRequest, i: number) => (
              <tr key={i} className="border-b border-[#D5CA8A]/30 hover:bg-[#FDF2B5]/30 transition-colors">
                <td className="px-2 py-1.5 text-[#666666]">{r.id}</td>
                <td className="px-2 py-1.5 text-[#2D2D2D]">{r.client}</td>
                <td className="px-2 py-1.5 text-[#666666]">{r.saleDoc}</td>
                <td className="px-2 py-1.5 text-[#2D2D2D] max-w-[120px] truncate" title={r.reason}>{r.reason}</td>
                <td className="px-2 py-1.5 text-[#DC2626] font-medium">{formatMoney(r.amount)}</td>
                <td className="px-2 py-1.5">
                  <span className={`inline-block px-1.5 py-0.5 rounded text-[9px] font-medium ${r.statusColor}`}>{r.status}</span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="px-3 py-1.5 border-t border-[#D5CA8A]">
        <button className="text-[10px] text-[#2D2D2D] hover:bg-[#FDF2B5] px-2 py-0.5 rounded transition-colors cursor-pointer">
          Все заявки
        </button>
      </div>
    </div>
  );
}